import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Queries {
  getApprovalsEquipments(): DocumentNode {
    return gql`
      query getApprovalsEquipments($where: ApprovalWhereInput, $orderBy: ApprovalOrderByInput, $limit: Int, $offset: Int) {
        approvals(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          items {
            id
            createdAt
            status
            notes
            resolvedAt
            resolvedBy {
              id
              name
              avatarUrl
            }
            equipment {
              originalEquipmentId
              qrCode
              number
              name
              notes
              createdAt
              type {
                id
                name
              }
              location {
                id
                name
              }
              attachments {
                id
                path
                title
                createdAt
                archived
              }
              customFields {
                id
                name
                value
                position
                type
              }
            }
            company {
              name
            }
          }
        }
      }
    `;
  }

  getApprovalEquipment(): DocumentNode {
    return gql`
      query approvalQuery($id: ID!) {
        approval(id: $id) {
          id
          createdAt
          status
          notes
          resolvedAt
          resolvedBy {
            id
            name
            email
          }
          equipment {
            id
            originalEquipmentId
            name
            number
            createdAt
            notes
            archived
            type {
              name
            }
            attachments {
              id
              path
              title
              createdAt
              archived
            }
            customFields {
              id
              name
              value
              type
              position
            }
            location {
              name
              address {
                formattedAddress
              }
            }
          }
          company {
            id
            name
            avatarUrl
            fieldAccountId
          }
        }
      }
    `;
  }

  getEquipmentsTypes(): DocumentNode {
    return gql`
      query equipmentsTypes($where: EquipmentTypeWhereInput, $orderBy: EquipmentTypeOrderByInput) {
        equipmentsTypes(where: $where, orderBy: $orderBy) {
          items{
            id
            name
          }
        }
      }
    `;
  }

  getEquipmentType(): DocumentNode {
    return gql`
      query equipmentTypeQuery($id: ID!) {
        equipmentType(id: $id) {
          id
          name
        }
      }
    `;
  }
}
